/**
 * El menú de la mano: sustituye la nav de admin cuando no cabe (020 · FR-003).
 */
import { NavLink } from 'react-router'

export function MenuMano({
    abierto,
    onCerrar,
    destinos,
    correo,
    etiquetaSalir,
    onSalir,
}: {
    abierto: boolean
    onCerrar: () => void
    destinos: { to: string; etiqueta: string }[]
    correo: string | null
    etiquetaSalir: string
    onSalir: () => void
}) {
    if (!abierto) return null
    return (
        <div className="fixed inset-0 z-50 md:hidden" role="presentation">
            <button
                type="button"
                aria-label="Cerrar menú"
                className="absolute inset-0 bg-black/60"
                onClick={onCerrar}
            />
            <aside
                role="dialog"
                aria-modal="true"
                aria-label="Menú"
                className="absolute inset-y-0 right-0 flex w-[min(20rem,100%)] flex-col border-l border-neutral-800 bg-neutral-950 pt-[max(1rem,env(safe-area-inset-top))] pr-[max(1rem,env(safe-area-inset-right))] pb-[max(1rem,env(safe-area-inset-bottom))] pl-4"
            >
                <div className="mb-3 flex items-center justify-between">
                    <p className="text-sm font-semibold text-neutral-100">Menú</p>
                    <button
                        type="button"
                        onClick={onCerrar}
                        className="flex h-11 w-11 items-center justify-center rounded-md text-neutral-300 hover:bg-neutral-900"
                        aria-label="Cerrar"
                    >
                        ×
                    </button>
                </div>
                <nav className="flex flex-col gap-0.5">
                    {destinos.map((d) => (
                        <NavLink
                            key={d.to}
                            to={d.to}
                            end={d.to === '/'}
                            onClick={onCerrar}
                            className={({ isActive }) =>
                                'flex min-h-11 items-center rounded-md px-3 text-sm ' +
                                (isActive
                                    ? 'bg-sky-500/20 text-sky-100'
                                    : 'text-neutral-300 hover:bg-neutral-900')
                            }
                        >
                            {d.etiqueta}
                        </NavLink>
                    ))}
                </nav>
                <div className="mt-auto space-y-2 border-t border-neutral-800 pt-3">
                    {correo && <p className="truncate px-3 text-xs text-neutral-500">{correo}</p>}
                    <button
                        type="button"
                        onClick={onSalir}
                        className="flex min-h-11 w-full items-center rounded-md px-3 text-left text-sm text-neutral-200 hover:bg-neutral-900"
                    >
                        {etiquetaSalir}
                    </button>
                </div>
            </aside>
        </div>
    )
}
